export default function getQuantityParam() {
    const queryString = window.location.search;
    const quantity = new URLSearchParams(queryString).get("quantity");
    if (quantity) {
        return Number(quantity);
    }
    return null;
}
//# sourceMappingURL=getQuantityParam.js.map